angular.module('SpidApp')

.filter('statusCommande',['gettextCatalog', function (gettextCatalog) {
        return function (status) {
            /**
                Order.prototype.STATUS_CREATE       = '0'
                Order.prototype.STATUS_CANCEL       = '1'
                Order.prototype.STATUS_TODO         = '2'
                Order.prototype.STATUS_IN_PROGRESS  = '3'
                Order.prototype.STATUS_SEND_PART    = '4'
                Order.prototype.STATUS_SEND         = '5'
                Order.prototype.STATUS_RECEIVE_PART = '6'
                Order.prototype.STATUS_RECEIVE      = '7'
            **/

            switch (status) {
                case 0:
                    return gettextCatalog.getString('ORDER_STATUS_CREATE');
                case 1:
                    return gettextCatalog.getString('ORDER_STATUS_CANCEL');
                case 2:
                    return gettextCatalog.getString('ORDER_STATUS_TODO');
                case 3:
                    return gettextCatalog.getString('ORDER_STATUS_IN_PROGRESS');
                case 4:
                    return gettextCatalog.getString('ORDER_STATUS_SEND_PART');
                case 5:
                    return gettextCatalog.getString('ORDER_STATUS_SEND');
                case 6:
                    return gettextCatalog.getString('ORDER_STATUS_RECEIVE_PART');
                case 7:
                    return gettextCatalog.getString('ORDER_STATUS_RECEIVE');
                case 8:
                    return 'Fermée';
                default:
                    return null
            }
        }
    }])

.filter('translate', ['gettextCatalog', function (gettextCatalog) {
    return function (s) {
        return gettextCatalog.getString(s);
    };
}]);